// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YidI_5RpM_ExPHvY2pJG{width:100%;max-width:380px;aspect-ratio:2/1}`, "",{"version":3,"sources":["webpack://./src/modules/feature-access/components/PlagiarismReportAnimation/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,UAAA,CACA,eAAA,CACA,gBAAA","sourcesContent":[".animation {\n  width: 100%;\n  max-width: 380px;\n  aspect-ratio: 2 / 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"animation": `YidI_5RpM_ExPHvY2pJG`
};
export default ___CSS_LOADER_EXPORT___;
